const resTol = require('./res-tol')

module.exports = {
  resTol
}
